import { InfoStyles } from '../../styles/styles';

const Info = () => {
  return (
    <InfoStyles data-scroll-section className="info">
      <div className="info-main">
        <h2>Languages</h2>
        <p>JavaScript(ES6+), TypeScript, Ruby, PostgreSQL, HTML5, CSS3/Sass</p>
        <h2>Frameworks & Libraries</h2>
        <p>
          React.js, Next.js, Node.js, Redux, Ruby on Rails, Firebase, Docker,
          GraphQL, Framer Motion, MaterialUI, TailwindCSS, Webpack, Git
        </p>
        <h2>Soft Skills</h2>
        <p>
          Remote Pair-Programming, Communication, Time Management, Teamwork,
          Problem Solving, Critical Thinking, Debugging
        </p>
        <h2>Learning</h2>
        <p>Docker, GraphQL, Ruby on Rails</p>
        <h2>Other Skills</h2>
        <p>Music Production, DJing, Audio Engineering, Content Marketing</p>
      </div>
      <div className="info-credits">
        <h1>Credits</h1>
        <p className="sm:text-[22px] text-[16px]">
          I developed this website with React.js, TypeScript, JavaScript,
          Three.js, Sass, TailwindCSS, and Framer Motion.
        </p>
        <p className="sm:text-[22px] text-[16px]">
          I want to acknowledge the sites and individuals who have served as my
          inspiration and provided the encouragement that fuels my learning and
          growth.
        </p>
        <h2>
          <a href="https://www.jsmastery.pro/" target="_blank" rel="noreferrer">
            Adrian Hadjin
          </a>
        </h2>
        <h2>
          <a href="https://www.loftgarten.co/" target="_blank" rel="noreferrer">
            Loftgarten
          </a>
        </h2>
        <h2>
          <a
            href="http://www.iaragrinspun.com/"
            target="_blank"
            rel="noreferrer">
            Iara Grinspun
          </a>
        </h2>
        <h2>
          <a
            href="https://www.ronniefeng.com/"
            target="_blank"
            rel="noreferrer">
            Ronnie Feng
          </a>
        </h2>
        <h2>
          <a href="https://hamishw.com/" target="_blank" rel="noreferrer">
            Hamish Williams
          </a>
        </h2>
        <h2>
          <a
            href="https://loerarchitecten.com/en/"
            target="_blank"
            rel="noreferrer">
            Loer Architecten
          </a>
        </h2>
        <h2>
          <a
            href="https://www.linkedin.com/in/wambuamakenzi/"
            target="_blank"
            rel="noreferrer">
            Andrew Makenzi
          </a>
        </h2>
        <h2>
          <a
            href="https://www.linkedin.com/in/odiegray/"
            target="_blank"
            rel="noreferrer">
            Odie Gray
          </a>
        </h2>
        <h2>
          <a
            href="https://www.linkedin.com/in/grayce-muthui/"
            target="_blank"
            rel="noreferrer">
            Grace Muthui
          </a>
        </h2>
        <h2>
          <a
            href="https://www.linkedin.com/in/akiura/"
            target="_blank"
            rel="noreferrer">
            Alex Kiura
          </a>
        </h2>
        <h2>
          <a
            href="https://www.linkedin.com/in/kelvinirungu/"
            rel="noreferrer"
            target="_blank">
            Kelvin Irungu
          </a>
        </h2>
      </div>
    </InfoStyles>
  );
};

export default Info;
